<section
  class="rf-card"
  [attr.aria-busy]="state().loading || releasesState() === 'loading' || null"
  [attr.aria-label]="'testResults.freigabe.label' | translate"
>
  <div class="rf-head">
    <span class="rf-head__label">{{ 'testResults.freigabe.label' | translate }}</span>
    @if (release(); as rel) {
      <span class="rf-head__meta">
        @if (rel.stichtag) {
          {{ 'testResults.freigabe.stichtag' | translate: { date: formatStichtag(rel.stichtag) } }} ·
        }
        {{ 'testResults.freigabe.status.' + rel.status | translate }}
        @if (summary(); as s) {
          ·
          {{
            (s.planCount === 1 ? 'testResults.freigabe.planCountOne' : 'testResults.freigabe.planCount')
              | translate: { count: s.planCount }
          }}
        }
      </span>
    }
    <span class="rf-head__spacer"></span>
    @if (ampel(); as a) {
      <app-ampel-badge data-testid="freigabe-ampel" [state]="a" [offeneFehler]="offeneFehlerKeys()" />
    }
  </div>

  @if (!releaseId() && releasesState() === 'loading') {
    <p class="rf-loading" role="status" data-testid="freigabe-loading">
      {{ 'testResults.freigabe.loading' | translate }}
    </p>
  } @else if (!releaseId() && releasesState() === 'error') {
    <p class="rf-error" role="alert">{{ 'testResults.releasesLoadError' | translate }}</p>
    <button type="button" class="rf-retry" data-testid="freigabe-releases-retry" (click)="releasesNeuLaden.emit()">
      {{ 'common.retry' | translate }}
    </button>
  } @else if (!releaseId() && releasesState() === 'loaded') {
    <p class="rf-empty">{{ 'testResults.freigabe.noRelease' | translate }}</p>
  } @else if (state().error) {
    <p class="rf-error" role="alert">{{ 'testResults.freigabe.loadError' | translate }}</p>
    <button type="button" class="rf-retry" data-testid="freigabe-retry" (click)="erneutLaden()">
      {{ 'common.retry' | translate }}
    </button>
  } @else if (state().loading && !summary()) {
    <p class="rf-loading" role="status" data-testid="freigabe-loading">
      {{ 'testResults.freigabe.loading' | translate }}
    </p>
  } @else if (summary(); as s) {
    <div class="rf-kpis">
      <div class="rf-kpi rf-kpi--progress" data-kpi="fortschritt">
        <div class="rf-kpi__label">{{ 'testResults.freigabe.kpi.progress' | translate }}</div>
        <div class="rf-kpi__row">
          <span class="rf-kpi__value">{{ s.fortschritt }}%</span>
          <span class="rf-kpi__inline">
            {{ 'testResults.freigabe.kpi.executedOf' | translate: { executed: s.ausgefuehrt, total: s.gesamt } }}
          </span>
        </div>
        <app-stack-bar
          class="rf-kpi__bar"
          [passed]="s.passed"
          [failed]="s.failed"
          [blocked]="s.blocked"
          [offen]="s.offen"
          [height]="10"
        />
        <div class="rf-legend">
          <span class="rf-legend__item">
            <span class="rf-legend__swatch rf-legend__swatch--passed" aria-hidden="true"></span>
            {{ 'testResults.freigabe.legend.passed' | translate }} {{ s.passed }}
          </span>
          <span class="rf-legend__item">
            <span class="rf-legend__swatch rf-legend__swatch--failed" aria-hidden="true"></span>
            {{ 'testResults.freigabe.legend.failed' | translate }} {{ s.failed }}
          </span>
          <span class="rf-legend__item">
            <span class="rf-legend__swatch rf-legend__swatch--blocked" aria-hidden="true"></span>
            {{ 'testResults.freigabe.legend.blocked' | translate }} {{ s.blocked }}
          </span>
          <span class="rf-legend__item">
            <span class="rf-legend__swatch rf-legend__swatch--open" aria-hidden="true"></span>
            {{ 'testResults.freigabe.legend.open' | translate }} {{ s.offen }}
          </span>
        </div>
      </div>

      <div class="rf-kpi" data-kpi="passrate">
        <div class="rf-kpi__label">{{ 'testResults.freigabe.kpi.passRate' | translate }}</div>
        <div class="rf-kpi__value" [attr.data-tone]="passRateTone(s.passRate)">{{ s.passRate }}%</div>
        <div class="rf-kpi__sub">{{ 'testResults.freigabe.kpi.passRateSub' | translate }}</div>
      </div>

      <div class="rf-kpi" data-kpi="blocker">
        <div class="rf-kpi__label">{{ 'testResults.freigabe.kpi.blockers' | translate }}</div>
        <div class="rf-kpi__value" [attr.data-tone]="blockerCount() > 0 ? 'bad' : 'good'">{{ blockerCount() }}</div>
        <div class="rf-kpi__sub">
          {{
            (blockerCount() > 0 ? 'testResults.freigabe.kpi.blockersSub' : 'testResults.freigabe.kpi.blockersNone')
              | translate
          }}
        </div>
        @if (blockerCount() > 0 && s.ohneFehlerTicket !== undefined) {
          <div class="rf-kpi__note" data-testid="blocker-ohne-fehler">
            {{ 'testResults.freigabe.kpi.blockersWithoutDefect' | translate: { count: s.ohneFehlerTicket } }}
          </div>
        }
      </div>

      <div class="rf-kpi" data-kpi="abdeckung">
        <div class="rf-kpi__label">{{ 'testResults.freigabe.kpi.coverage' | translate }}</div>
        <div
          class="rf-kpi__value"
          [attr.data-tone]="s.abdeckung.gesamt === 0 ? null : missingCoverage() === 0 ? 'good' : 'warn'"
        >
          {{ s.abdeckung.gedeckt }}/{{ s.abdeckung.gesamt }}
        </div>
        <div class="rf-kpi__sub">
          @if (s.abdeckung.gesamt === 0) {
            {{ 'testResults.freigabe.kpi.coverageNone' | translate }}
          } @else if (missingCoverage() === 0) {
            {{ 'testResults.freigabe.kpi.coverageAll' | translate }}
          } @else {
            {{ 'testResults.freigabe.kpi.coverageMissing' | translate: { count: missingCoverage() } }}
          }
        </div>
      </div>
    </div>

    @if (s.blocker.length > 0) {
      <div class="rf-blockers">
        <div class="rf-blockers__head">
          <span class="rf-blockers__label">{{ 'testResults.freigabe.blockerStrip' | translate }}</span>
          <span class="rf-blockers__count">{{ blockerCount() }}</span>
          <span class="rf-blockers__spacer"></span>
          @if (environment(); as gewaehlt) {
            <span class="rf-blockers__env-pill" data-testid="blocker-umgebung-pille">
              {{ 'testResults.freigabe.blockerEnvironmentOnly' | translate: { umgebung: umgebungLabel(gewaehlt) } }}
            </span>
          } @else {
            @for (u of blockerJeUmgebung(); track u.name) {
              <span class="rf-blockers__env-pill" data-testid="blocker-umgebung-pille">
                {{ u.name }} {{ u.anzahl }}
              </span>
            }
          }
          <span class="rf-blockers__summary">
            {{ 'testResults.freigabe.blockerSummary' | translate: blockerAufteilung() }}
          </span>
        </div>
        <div
          class="rf-blockers__table"
          role="table"
          [attr.aria-label]="'testResults.freigabe.blockerStrip' | translate"
        >
          <div class="rf-blockers__columns" role="row">
            <div role="columnheader">{{ 'testResults.freigabe.blockerColumns.testCase' | translate }}</div>
            <div role="columnheader">{{ 'testResults.freigabe.blockerColumns.title' | translate }}</div>
            <div role="columnheader">{{ 'testResults.freigabe.blockerColumns.plan' | translate }}</div>
            <div role="columnheader">{{ 'testResults.freigabe.blockerColumns.environment' | translate }}</div>
            <div role="columnheader">{{ 'testResults.freigabe.blockerColumns.result' | translate }}</div>
            <div role="columnheader">{{ 'testResults.freigabe.blockerColumns.bug' | translate }}</div>
            <div role="columnheader">{{ 'testResults.freigabe.blockerColumns.priority' | translate }}</div>
          </div>
          <div
            class="rf-blockers__scroll"
            role="rowgroup"
            tabindex="0"
            [attr.aria-label]="'testResults.freigabe.blockerScrollLabel' | translate"
          >
            @for (b of s.blocker; track b.planId + b.testCaseId) {
              <div class="rf-blocker" role="row" [attr.data-status]="b.status ?? 'NOT_RUN'">
                <div role="cell">
                  <code class="rf-blocker__id">{{ b.testCaseKey }}</code>
                </div>
                <div class="rf-blocker__title" role="cell" [attr.title]="b.titel">{{ b.titel }}</div>
                <div class="rf-blocker__plan-cell" role="cell">
                  @if (planKeys(b); as keys) {
                    <span class="sr-only">{{ 'testResults.freigabe.blockerPlans' | translate }}</span>
                    <code class="rf-blocker__plans" data-testid="blocker-plans">{{ keys }}</code>
                  } @else {
                    <span class="rf-blocker__none">—</span>
                  }
                </div>
                <div class="rf-blocker__env-cell" role="cell">
                  @if (b.umgebung; as umgebung) {
                    <span class="rf-blocker__env" [attr.title]="umgebung">{{ umgebung }}</span>
                  } @else {
                    <span class="rf-blocker__none">—</span>
                  }
                </div>
                <div role="cell">
                  @if (b.status && b.status !== 'NOT_RUN') {
                    <span class="rf-blocker__result">{{ 'testCases.executionStatus.' + b.status | translate }}</span>
                  } @else {
                    <span class="rf-blocker__state">{{ 'defect.ref.notRun' | translate }}</span>
                  }
                </div>
                <div class="rf-blocker__bug-cell" role="cell">
                  @if (b.bugKey) {
                    <code class="rf-blocker__bug">{{ b.bugKey }}</code>
                  } @else if (b.defects.length === 0) {
                    <span class="rf-blocker__none">—</span>
                  }
                  <app-defect-ref-chips [projectId]="projectId()" [defects]="b.defects" [compact]="true" />
                </div>
                <div role="cell">
                  @if (b.prio) {
                    <span class="rf-blocker__prio" [attr.data-prio]="b.prio">
                      {{ 'testCases.priority.' + b.prio | translate }}
                    </span>
                  } @else {
                    <span class="rf-blocker__none">—</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }

  @if (releaseId(); as rid) {
    <app-freigabe-bewertung
      [projectId]="projectId()"
      [releaseId]="rid"
      [aktualisierung]="aktualisierung()"
      [teststufe]="environment()"
      (decisionSaved)="onDecisionSaved($event)"
      (protokollExportieren)="protokollExportieren.emit()"
    />
  }
</section>

@if (regression(); as block) {
  <section
    class="rf-card"
    data-testid="regression-abschnitt"
    [attr.aria-label]="'testResults.regression.label' | translate"
  >
    <div class="rf-head">
      <span class="rf-head__label">{{ 'testResults.regression.label' | translate }}</span>
      <span class="rf-head__spacer"></span>
      <span class="rf-head__meta" data-testid="regression-gesamt">
        {{ 'testResults.regression.counts' | translate: block }}
      </span>
    </div>
    <ul class="rf-regression">
      @for (plan of block.plaene; track plan.id) {
        <li class="rf-regression__plan" data-testid="regression-plan">
          @if (plan.key) {
            <code class="rf-regression__key">{{ plan.key }}</code>
          }
          <span class="rf-regression__title" [attr.title]="plan.titel">{{ plan.titel }}</span>
          <span class="rf-regression__counts">{{ 'testResults.regression.counts' | translate: plan }}</span>
        </li>
      }
    </ul>
  </section>
}
